function canShowDownloadAppPrompt() {
	const isApp = (window.localStorage.CordovaEnableTracking || window.localStorage['IsApp'] === 'yes');
	const isBuyerApp = window.localStorage.getItem('isBuyerApp') === 'true';
	const isCordova = typeof getFCMtoken !== 'undefined';
	const isPWA = window.matchMedia('(display-mode: standalone)').matches;
	const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
	if (isApp || isBuyerApp || isCordova || isPWA || !isMobile) { return ''; }
	return isSafari ? 'Safari' : 'Android';
}

function goToStore() {
	const url = canShowDownloadAppPrompt() === 'Safari' ? 'https://apps.apple.com/pl/app/oferteo-dla-specjalist%C3%B3w/id1585161508' : 'https://play.google.com/store/apps/details?id=pl.oferteo.twa';
	if (url) {
		window.location.href = url;
	}
}

export { goToStore, canShowDownloadAppPrompt };
